module.exports = __webpack_public_path__ + "img/organize.93cc6982.png";